import React, {useEffect, useMemo, useState} from 'react';
import {Bar} from 'react-chartjs-2'
import {BarElement, CategoryScale, Chart as ChartJS, LinearScale, Tooltip} from 'chart.js'
import axios from "axios";
import {toast} from "react-toastify";
import Loader from "../../../Shared/Loader";
import {RequestState} from "../../../Shared/StateHelper";
import {t} from "../../../I18n/i18n";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip)

const ALL_MONTHS = "ALL"
const BAR_COLOR = "rgba(33, 150, 243, 0.8)"
const BAR_HEIGHT = 32

const NombreRdvs = () => {

    const [requestState, setRequestState] = useState(RequestState.LOADING)
    const [lastRdvs, setLastRdvs] = useState({labels: [], datasets: []})
    const [period, setPeriod] = useState(ALL_MONTHS)

    useEffect(() => {
        getLastRdvs()
    }, []);

    const getLastRdvs = () => {
        axios.get("/admin/statistiques/api/lastRdvs")
            .then((response) => {
                setLastRdvs(response.data)
                setRequestState(RequestState.SUCCESS)
            })
            .catch(() => {
                toast.error(t("OPHTHALMOLOGIST_DASHBOARD.TOAST.ERROR.CHART"))
                setRequestState(RequestState.ERROR)
            })
    }

    const monthLabel = ({month, year}) => `${t(`MONTH.${month}`)} ${year}`

    const totals = useMemo(() => {
        return lastRdvs.datasets
            .map((dataset) => ({
                label: dataset.label,
                total: period === ALL_MONTHS
                    ? dataset.data.reduce((sum, value) => sum + value, 0)
                    : dataset.data[period]
            }))
            .filter((orthoptist) => orthoptist.total > 0)
            .sort((a, b) => b.total - a.total)
    }, [lastRdvs, period])

    const renderPeriodSelect = () => {
        return <select className="browser-default" style={{maxWidth: 250}} value={period}
                       onChange={(event) => setPeriod(event.target.value === ALL_MONTHS ? ALL_MONTHS : Number(event.target.value))}>
            <option value={ALL_MONTHS}>{t("OPHTHALMOLOGIST_DASHBOARD.CHART.LAST_12_MONTHS")}</option>
            {lastRdvs.labels.map((label, index) => <option key={index} value={index}>{monthLabel(label)}</option>).reverse()}
        </select>
    }

    const renderChart = () => {
        if (!totals.length) return <div className="center">{t("OPHTHALMOLOGIST_DASHBOARD.CHART.NO_DATA")}</div>
        const data = {
            labels: totals.map((orthoptist) => orthoptist.label),
            datasets: [{
                label: t("OPHTHALMOLOGIST_DASHBOARD.CHART.EXAMS"),
                data: totals.map((orthoptist) => orthoptist.total),
                backgroundColor: BAR_COLOR,
                borderRadius: 4,
                maxBarThickness: 24
            }]
        }
        const options = {
            indexAxis: 'y',
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                x: {beginAtZero: true, ticks: {precision: 0}},
                y: {grid: {display: false}}
            },
            plugins: {
                legend: {display: false}
            }
        }
        return <div style={{height: totals.length * BAR_HEIGHT + 50}}>
            <Bar data={data} options={options}/>
        </div>
    }

    const renderLastRdvs = () => {
        if (requestState === RequestState.LOADING) return <div style={{height: "50vh", display: "flex", alignItems: "center", justifyContent: "center"}}>
            <Loader wide/>
        </div>
        if (requestState === RequestState.ERROR) return <div className="center">{t("OPHTHALMOLOGIST_DASHBOARD.TOAST.ERROR.CHART")}</div>
        if (requestState === RequestState.SUCCESS) return <>
            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap"}}>
                <h2 style={{margin: 0}}>{t("OPHTHALMOLOGIST_DASHBOARD.CHART.TITLE")}</h2>
                {renderPeriodSelect()}
            </div>
            {renderChart()}
        </>
    }

    return <div style={{
        border: "1px solid lightgrey",
        borderRadius: "10px",
        margin: 20,
        padding: 20,
        display: "flex",
        flexDirection: "column",
        gap: 20
    }}>
        {renderLastRdvs()}
    </div>
}

export default NombreRdvs;
